module.exports = __webpack_public_path__ + "img/gb847.prt.edf9de0b.jpg";